module.exports = __webpack_public_path__ + "img/progress-commission.0456e9d2.png";